<template>
  <div class="home">
    <b-container>
      <UserForm/>
    </b-container>
  </div>
</template>

<script>
import UserForm from '@/components/UserForm.vue';
export default {
  name: 'newuser',
  components: {
    UserForm
  }
}
</script>